var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.277 12.425c.183.19.422.284.66.284a.916.916 0 00.666-.288l.74-.778v3.559c0 .54.42.978.938.978s.938-.438.938-.978V9.675l7.13-7.484a.908.908 0 011.216-.003L19.783 9.7l-.002.029V20.09c0 1.078-.84 1.955-1.875 1.955H6.094c-1.034 0-1.875-.877-1.875-1.955 0-.54-.42-.978-.938-.978s-.937.438-.937.978c0 2.156 1.682 3.91 3.75 3.91h11.812c2.068 0 3.75-1.754 3.75-3.91v-8.44l.744.774a.91.91 0 001.326-.002 1.008 1.008 0 00-.001-1.382S13.842.755 13.829.743a2.725 2.725 0 00-3.75.008L.272 11.043a1.007 1.007 0 00.005 1.382z"
  })));
}
export default SvgIconHome;